import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { init, isTMA } from "@telegram-apps/sdk-react";
import { App } from "./App";
import "./styles/app.css";

/**
 * Initialise the Telegram WebApp SDK as early as possible.
 *
 * `@telegram-apps/sdk-react` 3.x is signal-based — no provider component. The
 * top-level `init()` call wires up event listeners and exposes the launch
 * params via `useRawInitData`, `useLaunchParams`, etc.
 *
 * Outside the Telegram environment (e.g. `npm run dev` opened in a regular
 * browser) `init()` would throw — we gate it on `isTMA()` and let `useAuth`
 * surface "Open from Telegram" instead.
 */
function bootstrap(): void {
  if (isTMA()) {
    init({ acceptCustomStyles: true });
  }

  const container = document.getElementById("root");
  if (!container) {
    throw new Error("Root element #root not found");
  }

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

bootstrap();
